import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 32.5161,
	height: 10.4255,
	viewBox: "0 0 32.5161 10.4255",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "visa-logo",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.12937 10.3443H5.31531L3.2051 2.25649C3.10494 1.88445 2.89227 1.55555 2.57945 1.40053C1.79875 1.01096 0.938479 0.700931 -1.84582e-07 0.544567V0.233185H4.53324C5.15889 0.233185 5.62813 0.700931 5.70634 1.24416L6.80123 7.07819L9.61393 0.233185H12.3498L8.12937 10.3443ZM13.9139 10.3443H11.2563L13.4447 0.233185H16.1023L13.9139 10.3443ZM19.5407 3.03429C19.6189 2.4897 20.0881 2.17832 20.6356 2.17832C21.4959 2.10014 22.433 2.25651 23.215 2.64472L23.6843 0.467747C22.9022 0.156365 22.0419 3.8147e-07 21.2612 3.8147e-07C18.6818 3.8147e-07 16.8048 1.40054 16.8048 3.34432C16.8048 4.82304 18.1343 5.59948 19.0728 6.06722C20.0881 6.53362 20.4792 6.845 20.401 7.3114C20.401 8.011 19.6189 8.32238 18.8382 8.32238C17.8997 8.32238 16.9612 8.08918 16.1023 7.69962L15.6331 9.87794C16.5716 10.2662 17.5869 10.4225 18.5254 10.4225C21.4176 10.4994 23.215 9.10016 23.215 7.00002C23.215 4.3553 19.5407 4.20028 19.5407 3.03429V3.03429ZM32.5161 10.3443L30.4059 0.233185H28.1393C27.6701 0.233185 27.2008 0.544567 27.0444 1.01096L23.1368 10.3443H25.8727L26.4188 8.86694H29.7803L30.0931 10.3443H32.5161ZM28.5303 2.95612L29.311 6.76683H27.1226L28.5303 2.95612Z",
		fill: "#172B85"
	})
});
export default SvgVisa;
